<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text class="d-flex">
      <v-avatar
        rounded
        size="120"
        class="me-6"
      >
        <v-img
          v-if="!accountdata.img"
          :src="require('@/assets/images/avatars/1.png')"
        ></v-img>
        <v-img
          v-else
          :src="ReturnLink(accountdata.img)"
        ></v-img>
      </v-avatar>

      <!-- upload photo -->
      <div>
        <v-btn
          color="primary"
          class="me-3 mt-5"
          @click="$refs.refInputEl.click()"
        >
          <v-icon class="d-sm-none">
            {{ icons.mdiCloudUploadOutline }}
          </v-icon>
          <span class="d-none d-sm-block">Upload new photo</span>
        </v-btn>

        <input
          ref="refInputEl"
          type="file"
          accept=".jpeg,.png,.jpg,GIF"
          :hidden="true"
          @change="UploadFoto"
        />

        <p class="text-sm mt-5">
          Allowed JPG, GIF or PNG. Max size of 800K
        </p>
      </div>
    </v-card-text>

    <v-card-text>
      <v-form class="multi-col-validation mt-6">
        <v-row>
          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="account.name"
              label="Name"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="account.email"
              label="E-mail"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="account.level_user"
              dense
              label="Role"
              readonly
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="account.phone"
              dense
              outlined
              label="Phone"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              @click="SaveAccount()"
            >
              Save changes
            </v-btn>

          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiAlertOutline, mdiCloudUploadOutline } from '@mdi/js'
import axios from 'axios'

export default {
  props: ['accountdata'],
  data() {
    return {
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
      },
      account: {
        id_user: '',
        name: '',
        level_user: '',
        email: '',
        phone: '',
      },
    }
  },
  mounted() {
    this.account = this.accountdata
  },
  methods: {
    SaveAccount() {
      this.$root.$emit('PesanLoading', 'Proses Login')
      axios.post('auth/user/SaveAccount', this.account).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.$store.commit('setUser', this.account)
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    ReturnLink(img) {
      return `${process.env.VUE_APP_apiURL}/foto/${img}`
    },
    UploadFoto(e) {
      this.$root.$emit('PesanLoading', 'Uploading Profile Picture')
      axios.post('auth/UploadFoto', { id_user: this.$store.state.user.id_user, file: e.target.files[0] }, {
        headers: {
          'content-type': 'multipart/form-data', // do not forget this
        },
      }).then(response => {
        this.$store.commit('UpdateFoto', response.data.data.img)
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
      }).catch(err => {
        this.errors = err.response.data.errors

        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
